import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GetMultiCounty from './GetMultiCounty.graphql';

export const useGetMultiCounty = (options) =>
  useCustomQuery(GetMultiCounty, {
    url: config('GRAPHQL_API_URL'),
    accessor: 'getMultiCounty',
    ...options,
  });
